<script setup lang="ts">
import type { TagTrimmed } from "~/common/interfaces/tag-trimmed";

defineProps({
	tags: {
		type: Array as PropType<TagTrimmed[]>,
		default () {
			return [];
		}
	}
});

const { ids, switchQueryId } = useQueryValueIdMapping("tags");
</script>

<template>
	<ul class="pt-3 flex flex-wrap gap-3 max-w-[256px]">
		<li v-for="{id, name} in tags" :key="id">
			<CommonCheckboxTag
				:model-value="ids.includes(id)"
				@update:model-value="switchQueryId(id)"
			>
				{{ name }}
			</CommonCheckboxTag>
		</li>
	</ul>
</template>
